<template>
<div>
    <a id="downloadLink"></a>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary  mcc-dialog--sm" id="attachment-dialog" ref="attachmentDialog">
            <form  @submit.prevent="addAttachment($event)" id="attachment-dialog-form" novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Attachments</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.attachmentDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div style="position:relative">
                            <div class="mcc-card"><div class="mcc-card__body">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                       
                               
                                  
                               
                               
                                    <h5 class="sub-title">Add attachment</h5>
                                    <div class="mcc-segmented-buttons mcc-segmented-buttons--sm mfc-form-input-container">
                                    <fieldset  :disabled="(taskObj.isCompleted) ? 'disabled' : null" id="attachment-type" name="attachmentType" ref="radioRef" class="mfc-fieldset mu-mb-03"  >
                                        <legend class="mfc-label mfc-label--required">Type</legend>
                                        <div class="mcc-segmented-buttons__list ">
                                            <input id="attachment" value="Attachment" name="attachmentType" type="radio" @click="handleAttachmentTypeChange($event)" >
                                            <label class="mcc-segmented-buttons__button" for="attachment"><span class="mcc-segmented-buttons__label">Attachment</span></label>
                                       
                                            <input id="externalResource" value="External resource" name="attachmentType" type="radio" @click="handleAttachmentTypeChange($event)">
                                            <label class="mcc-segmented-buttons__button" for="externalResource"><span class="mcc-segmented-buttons__label">External resource</span></label>
                                        </div>
                                    </fieldset>
                                    </div>
                                    <div class="mcc-row" v-if="attachmentType != 'Attachment'">
                                        <div class="mcc-col">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                <label for="name-attachment" class="mfc-label--required">Name</label>
                                                <input type="text" id="name-attachment" ref="name" name="attachmentName" required="" :pattern="nameRegex" :disabled="(taskObj.isCompleted) ? 'disabled' : null" :value="attachmentName" @change="updateName($event)" maxlength="50">
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                        <label for="desc-attachment">Description</label>
                                        <textarea id="desc-attachment" name="attachmentDescription" maxlength="100" ref="descRef" :disabled="(taskObj.isCompleted) ? 'disabled' : null" :value="attachmentDescription" @input="attachmentDescription = $event.target.value" character-count=""></textarea>
                                        <div class="mfc-invalid-feedback"></div>  <div class="mfc-help-text mu-mt-00">
                                            
                                        <span>You have {{100 - attachmentDescription.length}} characters remaining</span>
                                    </div>
                                    </div>
                                   
                                    <div class="mcc-row mu-mt-05" v-if="attachmentType == 'Attachment'">
                                        <div class="mcc-col">
                                            <div class="form-group">
                                                <mfc-file-upload 
                                                maxfiles="1" maxfilesize="10" 
  subtitle="File types Text, images, or csv, up to a maximum of 10MB"
  :disabled="(taskObj.isCompleted) ? 'disabled' : null"
  name="files" 
  required 
  options="{&quot;url&quot;:&quot;/tasks-api/add-attachment&quot;,&quot;acceptedFiles&quot;:&quot;.zip,.txt,.csv&quot;,&quot;maxFilesize&quot;:10,&quot;maxFiles&quot;:1,&quot;addRemoveLinks&quot;:true,&quot;uploadMultiple&quot;:false,&quot;autoProcessQueue&quot;:false,&quot;paramName&quot;:&quot;files&quot;}"
>
</mfc-file-upload>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mcc-row" v-if="attachmentType != 'Attachment'">
                                        <div class="mcc-col">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                                <label for="ext-link" class="mfc-label--required">Link to external resource</label>
                                                <input type="text" id="ext-link" ref="externalResourceLink" required="" name="externalResourceLink" maxlength="250" :disabled="(taskObj.isCompleted) ? 'disabled' : null" :value="externalResourceLink" @change="updateExternalResourceLink($event)">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="mu-my-05 mu-d-flex mu-justify-content-end">
                                        <button type="button" @click="addAttachment()" class="mcc-button mcc-button--soft-primary">
                                            <mcc-icon name="plus_math" aria-hidden="true"></mcc-icon>
                                            <span class="mcc-buttton__label"> Add</span>
                                        </button>
                                    </div> -->
                                    <div class="mu-mt-08">
                                      <mcc-data-table  ref="attachmentTable" id="attachmentTableId"></mcc-data-table>
                                      </div>
                                    </div>
                                </div>
                          
                </div></div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.attachmentDialog.close()">Cancel</button>
                            <button type="submit" class="mcc-button mcc-button--primary">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import MyTaskListAPI from "@/services/MyTaskListAPI";
import Table from "@advanced/component-mosaic-table";
import Utils from "@/script_utils";
import constantMessages from "@/messages";
import constants from "@/constants";
import {
    EventBus
} from "@/services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    props: ['taskId', 'taskObj'],
    data() {
        return {
            attachments: [],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            attachmentName: '',
            attachmentDescription: '',
            attachmentType: 'Attachment',
            externalResourceLink: '',
            files: {},
            updateCall: true,
            dropzoneObj: null
        }
    },
    created() {
        this.getTaskAttachments(false);
    },
    methods: {
        handleAttachmentTypeChange(e) {
            this.attachmentType = e.target.value;
            $('#attachment-dialog form').removeClass("ms-was-validated");
            this.waitDropzoneShown();
        },
        async waitDropzoneShown() {
            await this.$nextTick();
            if (this.attachmentType == 'Attachment') {
                this.initializeDropzone();
            }
        },
        resetAttachmentDialog() {
            const dropzoneElement = document.querySelector("mfc-file-upload .dropzone");
            if (dropzoneElement !== null)
            dropzoneElement.dropzone.removeAllFiles();
            $('#attachment-dialog form')[0].reset();
            
        },
        addAttachment(isSubmit) {
            let form = $('#attachment-dialog-form')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            if (!this.taskObj.isCompleted) {
                if (this.attachmentType == 'Attachment') {
                    this.postAttachmentData(isSubmit);
                } else {
                    this.postExternalSystemUrl(isSubmit);
                }
            } else {
                this.$refs.attachmentDialog.close();
            }
        },
        postAttachmentData(isSubmit) {
            let self = this;
            let formDataArray = $('#attachment-dialog').find("form").serializeArray();
            let form_data = new FormData();
            const dropzone = document.querySelector("mfc-file-upload .dropzone").dropzone;
            if (Utils.appendDropzoneData(form_data, dropzone)) {
                self.updateCall = false;
        
                for (let key in formDataArray) {
                    form_data.append(formDataArray[key].name, formDataArray[key].value);
                }
                MyTaskListAPI.addAttachment(this.taskId, form_data)
                    .then(result => {
                        self.updateCall = true;
                        if(isSubmit)
                        this.$refs.attachmentDialog.close();
                        if (result.error) {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[result.message]
                            });
                        } else {
                            EventBus.$emit('success-notification', {
                                "msg": constantMessages.MESSAGES[result.message]
                            });
                            self.$emit('updateAttachmentCount', result.data);
                            if(!isSubmit)
                            this.attachmentShowHandler(true)
                        }
                    })
                    .finally(() => {

                    });
            }
        },
        postExternalSystemUrl(isSubmit) {
            let self = this;
            let formDataArray = $('#attachment-dialog').find("form").serializeArray();
            let form_data = new FormData();
            for (let key in formDataArray) {
                form_data.append(formDataArray[key].name, formDataArray[key].value);
            }
            self.updateCall = false;
            let url = null;

            try {
                url = new URL(self.externalResourceLink);
            }
            catch(err) {
                console.log(err)
            }
 
            if( !url.hostname || !url.hostname.includes('oneadvanced.')) {
                EventBus.$emit('error-notification', {
                    "msg": constantMessages.MESSAGES["error.url.invalid"]
                });
                self.updateCall = true;
                return;
            }
            MyTaskListAPI.addAttachmentWithExternalSystem(this.taskId, form_data)
                .then(result => {
                    self.updateCall = true;

                    if(isSubmit)
                    this.$refs.attachmentDialog.close();

                    if (result.error) {
                        EventBus.$emit('error-notification', {
                            "msg": constantMessages.MESSAGES[result.message]
                        });
                        return;
                    }
                    EventBus.$emit('success-notification', {
                        "msg": constantMessages.MESSAGES[result.message]
                    });
                    self.$emit('updateAttachmentCount', result.data);
                    if(!isSubmit)
                    this.attachmentShowHandler(true)
                })
                .finally(() => {
                    
                });
        },
        getTaskAttachments(loadTable) {
            let self = this;
            MyTaskListAPI.getTaskAttachments(this.taskId)
                .then(result => {
                    self.attachments = result.data;
                })
                .finally(() => {
                    self.$emit('updateAttachmentCount', self.attachments.length);
                    if (loadTable) {
                        self.initAttachmentsTable();
                    }
                });
        },
        deleteAttachment(id) {
            let self = this;
            self.updateCall = false;
            MyTaskListAPI.deleteAttachment(this.taskId, id)
                .then(result => {
                    if (result.error) {
                        EventBus.$emit('error-notification', {
                            "msg": constantMessages.MESSAGES[result.message]
                        });
                    } else {
                        EventBus.$emit('success-notification', {
                            "msg": constantMessages.MESSAGES[result.message]
                        });
                        self.attachments = result.data;
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                    self.$emit('updateAttachmentCount', self.attachments.length);
                    self.initAttachmentsTable();
                });
        },
        dropzoneExists(selector) {
            return $(selector).hasClass('dz-clickable');
        },
        initializeDropzone() {
            let self = this;
            $("#attachment-dialog .dropzone").each(function () {
                let arr = ["csv", "zip", "txt"];
                $(this).attr("filetypes", JSON.stringify(arr));
                self.dropzoneObj = Utils.bindDropzone(this, $(this).attr("name"), `/tasks-api/${self.taskId}/add-attachment`, false);
            });
        },
        attachmentShowHandler(isAdd) {
            $('#attachment-dialog form')[0].reset();
            this.attachmentName = '';
            this.externalResourceLink = '';
            this.attachmentDescription = '';
            if(!isAdd)
            {
            this.$refs.attachmentDialog.show();
            setTimeout(() => {
                this.attachmentType = 'Attachment';
            });
            $('#attachment-dialog').find("form").attr('enctype', 'multipart/form-data');
            this.attachmentType = 'Attachment';
        }
           
        this.resetAttachmentDialog();
        if (this.attachmentType == 'Attachment') {
    $('#attachment').prop('checked', true);
} else {
    $('#externalResource').prop('checked', true);
}
            this.getTaskAttachments(true);
        },
        appendActionInAttachmentTable() {
            let self = this;
            this.attachments.forEach(function (obj, index) {
                let actionsObj = {
                    deleteAction: {
                        disabled: self.taskObj.isCompleted
                    }
                }
                obj['actions'] = actionsObj;
            })
        },
        initAttachmentsTable() {
            this.appendActionInAttachmentTable();
            let self = this;
            const table = document.getElementById("attachmentTableId");
            self.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No attachments found</p>',
                columnSearch: false,
                pageSize: 10,
                fixedHeight:true,
                debounceTime: 1000,
                totalCount: self.attachments.length,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            template(rowData, html) {
                                return html `<a class="name-link" onclick="${() => self.downloadOrOpenLink(`${JSON.stringify(rowData)}`)}">${rowData.name}</a>`
                            },
                        },
                        description: {
                            type: "string",
                            sortable: true,
                            title: "Description",
                        },
                        delete: {
                          
                            title: "Actions",
                          
                                    type: "string",
                                 
                                    template(rowData, html) {
                                return html `<button onclick="${() => self.deleteAttachment(rowData.id)}" type="button" title="deleteAction" class="mcc-button mcc-button--sm mcc-button--soft-danger mcc-button--icon-only mu-ml-03"><mcc-icon name="trash" aria-hidden="true" class="mcc-icon"></mcc-icon></button>`
                            },
                           
                        }
                    }
                },
                data: () => {
                    return self.attachments;
                },
                onAction: (table, action, [{
                    index,
                    rowData,
                    value
                }]) => {                    
                    if (action == "deleteAction") {
                        
                    } else if (action == "name") {
                        if (rowData.type == 'External resource') {
                            window.open(rowData.url)
                        } else {
                            let attachmentName = rowData.name;
                            let extension = attachmentName.substr(attachmentName.lastIndexOf(".") + 1, attachmentName.length);
                            let downloadFormURL = constants.BASE_URL + `/tasks-api/file-attachements/task/` +
                                self.taskId + '/attachment/' + rowData.id + '/attachment-name/' + rowData.name + '/extension/' +
                                extension;

                            $("#downloadLink").attr('href', downloadFormURL);
                            $("#downloadLink")[0].click();
                        }
                    }
                }
            });
        },
        downloadOrOpenLink(rowData) {
            rowData = JSON.parse(rowData);
            if (rowData.type == 'External resource') {
                window.open(rowData.url)
            } else {
                let attachmentName = rowData.name;
                let extension = attachmentName.substr(attachmentName.lastIndexOf(".") + 1, attachmentName.length);
                let downloadFormURL = constants.BASE_URL + `/tasks-api/file-attachements/task/` +
                    this.taskId + '/attachment/' + rowData.id + '/attachment-name/' + rowData.name + '/extension/' +
                    extension;

                $("#downloadLink").attr('href', downloadFormURL);
                $("#downloadLink")[0].click();
            }
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid");
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid");
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.attachmentName = event.target.value
        },
        updateExternalResourceLink(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.externalResourceLink), "Link to external resource is required")
                self.$refs.externalResourceLink.classList.add("ms-is-invalid");
            } else {
                self.$refs.externalResourceLink.classList.remove("ms-is-invalid")
            }
            self.externalResourceLink = event.target.value
        }
    }
}
</script>
